import Checkbox from './Checkbox/index.js';
import Radio from './Radio/index.js';
import BoxRadio from './BoxRadio/index.js';
import SegmentedControl from './SegmentedControl/index.js';
import Switch from './Switch/index.js';

var index = { Checkbox: Checkbox, Radio: Radio, BoxRadio: BoxRadio, SegmentedControl: SegmentedControl, Switch: Switch };

export { index as default };
